import { createStaticReducer } from '../../../AppModulesWrapper/utils/redux/createStaticReducer';
import { IDynamicPricingAttributesState } from '../../types/reducers/dynamicPricing';

export const dynamicPricingAttributes = createStaticReducer<IDynamicPricingAttributesState>();
